"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var TableSelectSearchBox = function TableSelectSearchBox(_a) {
  var _b, _c, _d;
  var column = _a.column,
    searchTerms = _a.searchTerms,
    columnSelectFilterOptions = _a.columnSelectFilterOptions,
    onSearchChange = _a.onSearchChange;
  var _e = (0, _react.useState)({}),
    searchLabels = _e[0],
    setSearchLabels = _e[1];
  (0, _react.useEffect)(function () {
    var map = {};
    columnSelectFilterOptions[column.title].forEach(function (option) {
      var _a;
      map[option.value] = (_a = option.label) !== null && _a !== void 0 ? _a : '';
    });
    setSearchLabels(map);
  }, [column.title, columnSelectFilterOptions]);
  return (0, _jsxRuntime.jsxs)(_material.FormControl, __assign({
    sx: {
      m: 1,
      minWidth: '10em'
    }
  }, {
    children: [(0, _jsxRuntime.jsx)(_material.InputLabel, __assign({
      id: "column-".concat(column.title, "-select-box")
    }, {
      children: "Select"
    })), (0, _jsxRuntime.jsx)(_material.Select, __assign({
      labelId: "column-".concat(column.title, "-select-box"),
      multiple: true,
      value: (_c = (_b = searchTerms[column.title]) === null || _b === void 0 ? void 0 : _b.searchValue) !== null && _c !== void 0 ? _c : [],
      onChange: function onChange(event) {
        return onSearchChange({
          searchType: 'select',
          searchValue: Array.isArray(event.target.value) ? event.target.value : [event.target.value]
        }, column.title);
      },
      input: (0, _jsxRuntime.jsx)(_material.OutlinedInput, {
        label: "Select"
      }),
      renderValue: function renderValue(selected) {
        return selected.map(function (value) {
          return searchLabels[value];
        }).join(', ');
      },
      style: {
        minWidth: '160px'
      }
    }, {
      children: (_d = columnSelectFilterOptions[column.title]) === null || _d === void 0 ? void 0 : _d.map(function (option, i) {
        var _a;
        return (0, _jsxRuntime.jsxs)(_material.MenuItem, __assign({
          value: option.value
        }, {
          children: [(0, _jsxRuntime.jsx)(_material.Checkbox, {
            checked: !!(((_a = searchTerms[column.title]) === null || _a === void 0 ? void 0 : _a.searchValue.indexOf(option.value)) > -1)
          }), (0, _jsxRuntime.jsx)(_material.ListItemText, {
            primary: option.label
          })]
        }), i);
      })
    }))]
  }));
};
TableSelectSearchBox.propTypes = {
  column: _propTypes.default.object.isRequired,
  searchTerms: _propTypes.default.object.isRequired,
  columnSelectFilterOptions: _propTypes.default.object.isRequired,
  onSearchChange: _propTypes.default.func.isRequired
};
var _default = TableSelectSearchBox;
exports.default = _default;